import {Injectable} from '@angular/core';
import {ConfigService} from '../config/config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ValidationError} from '../../models/validationError';
import {ObservableApiService} from './observable-api.service'

@Injectable()
export class ApiService {
  baseUrl: string;

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    public observable: ObservableApiService,
  ) {
    const apiSettings = config.get('api');
    this.baseUrl      = apiSettings['proto'] + '://' + apiSettings['host'] + '/';
  }

  /**
   * @param url
   */
  public async get(url: string) {
    try {

      const result = await new Promise((resolve, reject) => {
        this.http.get(this.baseUrl + url).subscribe(data => {
          resolve(data);
        }, error => {
          reject(this.mapError(error));
        });
      });
      return result;
    } catch (error) {
      // Something went horribly wrong, like having no internet. You peasant.
      return Promise.reject(error);
    }
  }

  public async download(url: string) {
    try {
      let result = await new Promise((resolve, reject) => {
        this.http.get(this.baseUrl + url, {responseType: 'blob'}).subscribe(data => {
          resolve(data);
        }, error => {
          reject(this.mapError(error));
        });
      });
      return result;
    } catch (error) {
      // Something went horribly wrong, like having no internet. You peasant.
      return Promise.reject(error);
    }
  }


  public async post(url: string, data: Object) {
    try {
      let result = await new Promise((resolve, reject) => {
        this.http.post(this.baseUrl + url, data).subscribe(data => {
          resolve(data);
        }, error => {
          reject(this.mapError(error));
        });
      });
      return result;
    } catch (error) {
      // Something went horribly wrong, like having no internet. You peasant.
      return Promise.reject(error);
    }
  }

  public async put(url: string, data: Object) {
    try {
      let result = await new Promise((resolve, reject) => {
        this.http.put(this.baseUrl + url, data).subscribe(data => {
          resolve(data);
        }, error => {
          reject(this.mapError(error));
        });
      });
      return result;
    } catch (error) {
      // Something went horribly wrong, like having no internet. You peasant.
      return Promise.reject(error);
    }
  }

  public async patch(url: string, data: Object) {
    const httpOptions = {
      headers: new HttpHeaders({'Accept': 'application/json'})
    };

    try {
      let result = await new Promise((resolve, reject) => {
        this.http.patch(this.baseUrl + url, data).subscribe(data => {
          resolve(data);
        }, error => {
          reject(this.mapError(error));
        });
      });
      return result;
    } catch (error) {
      // Something went horribly wrong, like having no internet. You peasant.
      return Promise.reject(error);
    }
  }

  public async delete(url: string) {
    try {
      let result = await new Promise((resolve, reject) => {
        this.http.delete(this.baseUrl + url).subscribe(data => {
          resolve(data);
        }, error => {
          reject(this.mapError(error));
        });
      });
      return result;
    } catch (error) {
      // Something went horribly wrong, like having no internet. You peasant.
      return Promise.reject(error);
    }
  }

  public mapError(data) {
    let rc = data;
    if (data.status == 422) {
      rc         = new ValidationError();
      rc.message = data.error.message;
      rc.errors  = data.error.errors;

    }
    return rc;
  }

  /**
   * Gets all from a pagination endpoint. For real. None of that pagination stuff.
   * Returns an array of values and not a Paginator, so keep that in mind when replacing a 'get' call and handling
   * 'data.data'.
   * @param url
   * @param page
   * @param rc
   * @param extra
   */
  public all(url: string, page: number = 1, rc = [], extra = '') {
    const vm = this;

    return new Promise((resolve, reject) => {
      return vm.get(url + '?page=' + page + '&limit=100' + extra).then(data => {
        rc = rc.concat(data['data']);

        if (data['meta']['last_page'] > data['meta']['current_page']) {
          return resolve(this.all(url, page + 1, rc, extra));
        } else {
          return resolve(rc);
        }
        ;
      });
    });
  }
}
